export const constants = {
  defaultGiftAmount: 50,
  defaultNumInstallments: 24,
  MAX_GIFT_AMOUNT: 50000,
  MIN_GIFT_AMOUNT: 1,
  minInstallmentAmount: 2,
  maxNumInstallments: 25,
  minNumInstallments: 2,
  numRecurringInstallments: 149
}